module.exports = __webpack_public_path__ + "media/images/icons/filled/check-square-4c656eb99fec321756a56f4c933e88f7.svg";